import React from "react"
import { secondaryWheelserviceListItemType, secondaryWheelserviceType } from "../../types/mainModulTypes"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { API } from "../../constants/constants"

export default function SecondaryWheelservice(props: secondaryWheelserviceType) {
    return (
        <div className="max-w-content mx-auto grid grid-cols-2 sm:gap-x-20 md:gap-x-32 gap-y-8 sm:gap-y-16 px-4">
            <div className="row-span-2 col-span-2 sm:col-span-1">
                <BaseSubheadline label={props.secondaryWheelserviceIntroHeading} classProps="pb-2" />
                <BaseRichtext content={props.secondaryWheelserviceIntroText} />
            </div>
            <div>
                <BaseSubheadline label="KFZ-Annahme:" />
                <BaseRichtext content={props.secondaryWheelserviceIntroReception} />
            </div>
            <div>
                <BaseSubheadline label="KFZ-Abholung" />
                <BaseRichtext content={props.secondaryWheelserviceIntroPickUp} />
            </div>
            <div className="pt-4 sm:pt-0 col-span-2 sm:col-span-1">
                <BaseSubheadline label={props.secondaryWheelserviceListHeading} classProps="pb-2" />
                <BaseRichtext content={props.secondaryWheelserviceListText} />
            </div>
            <div className="hidden sm:block" />
            <div className="col-span-2 flex flex-col gap-8 sm:gap-16">
                {props.secondaryWheelserviceListBlock.map((listItem, index) => (
                    <ListItem {...listItem} key={index} />
                ))}
            </div>
        </div>
    )
}

function ListItem(props: secondaryWheelserviceListItemType) {
    return (
        <div className="grid sm:grid-cols-2 gap-x-32 ">
            <BaseRichtext content={props.secondaryWheelserviceListEntryText} classProps="pb-4" />
            {props.secondaryWheelserviceListEntryBlock.map((entryBlock, index) => {
                const isText = entryBlock.type === "secondaryWheelserviceListEntryBlockText"
                const iconBlockLength = entryBlock.secondaryWheelserviceListEntryBlockIconsBlock?.length

                return isText ? (
                    <BaseRichtext
                        key={index}
                        content={entryBlock.secondaryWheelserviceListEntryBlockTextText}
                        classProps="flex items-center -mt-2 sm:mt-0"
                    />
                ) : (
                    <div
                        key={index}
                        className={`flex justify-start items-end gap-4 ${iconBlockLength && iconBlockLength >= 4 ? "flex-wrap sm:flex-nowrap" : ""}`}>
                        {entryBlock.secondaryWheelserviceListEntryBlockIconsBlock?.map((icon, iconIndex) => (
                            <div key={iconIndex} className="flex flex-col w-fit relative pb-8">
                                <img
                                    src={API + icon.secondaryWheelserviceListEntryBlockIconsBlockEntryIcon?.url}
                                    alt={
                                        icon.secondaryWheelserviceListEntryBlockIconsBlockEntryIcon?.description ||
                                        icon.secondaryWheelserviceListEntryBlockIconsBlockEntryIcon?.name
                                    }
                                    className="w-24 object-contain -mb-[.375rem] relative"
                                />
                                <BaseRichtext
                                    classProps="text-center bg-gray-200 px-2 py-3 rounded-b-default"
                                    content={icon.secondaryWheelserviceListEntryBlockIconsBlockEntryText}
                                />
                            </div>
                        ))}
                    </div>
                )
            })}
        </div>
    )
}
